<template>
  <router-view/>
</template>

<script>
export default {
  name: 'DataMain'
}
</script>

<style scoped>

</style>
